import React from 'react'
import { TopParty } from '../data'
import {
    TheRaceBarIndicatorContainer,
    TheRaceBarIndicator,
    TheRacePartyInnerRowContainer,
    TheRacePartyRowContainer,
    StyledRaceElectionText,
    StyledRaceAmountText,
} from './TheRaceRow.styled'

export interface TheRaceRowProps {
    party: TopParty
    percentPerSeat: number
}

export const TheRaceRow = ({ party, percentPerSeat }: TheRaceRowProps) => {
    const color = party.color
    const predictedColor = party.predictedColor

    const predictedPercent = percentPerSeat * party.seatsPredicted
    const percent = percentPerSeat * party.seats

    const isFull = predictedPercent >= 100

    const BarComponent = (
        <TheRaceBarIndicatorContainer>
            <TheRaceBarIndicator
                widthPercent={predictedPercent}
                color={predictedColor}
            />
            <TheRaceBarIndicator widthPercent={percent} color={color} />
            <StyledRaceAmountText barPercent={predictedPercent}>
                {party.seatsPredicted}
            </StyledRaceAmountText>
        </TheRaceBarIndicatorContainer>
    )

    return (
        <TheRacePartyRowContainer key={party.code}>
            <TheRacePartyInnerRowContainer>
                <StyledRaceElectionText>{party.name}</StyledRaceElectionText>
                {BarComponent}
            </TheRacePartyInnerRowContainer>
            {/* <SampleMiniHorseShoeData /> TODO: Re-enable this when it's done */}
        </TheRacePartyRowContainer>
    )
}
